// extracted by mini-css-extract-plugin
export default {"title":"Children_title__U-S3v","charts":"Children_charts__fTRsT"};